import React from 'react';
import './App.css';
// components
import { Header } from './components/HeaderComponent';
import { Footer } from './components/FooterComponent';

function App() {
  return (
    <div className="App">
      <Header/>

      <Footer/>
    </div>
  );
}

export default App;
